import { useMemo } from "react";
import { useAuth } from "@/components/hooks/useAuth";

const useAuthAwarePublicQueryGate = () => {
  const { authResolved, isAuthenticated } = useAuth();

  return useMemo(
    () => ({
      authResolved: Boolean(authResolved),
      isAuthenticated: Boolean(isAuthenticated),
    }),
    [authResolved, isAuthenticated]
  );
};

export default useAuthAwarePublicQueryGate;
